// featureFlags.js — fetches public feature flags from the Workers endpoint.
// Used for nav-level flags (e.g. nav.pottering) that affect all users on app
// load. Caches in localStorage for 5 minutes; fails gracefully (returns {}).
import { getApiBase } from './sync.js';

const CACHE_KEY = 'tend:publicFlagsCache';
const CACHE_TTL = 5 * 60 * 1000;

export async function getPublicFlags() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (raw) {
      const { ts, flags } = JSON.parse(raw);
      if (Date.now() - ts < CACHE_TTL) return flags;
    }
  } catch {}

  try {
    const res = await fetch(`${getApiBase()}/feature-flags`, {
      signal: AbortSignal.timeout(3000),
    });
    if (!res.ok) return {};
    const flags = await res.json();
    if (flags && typeof flags === 'object') {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), flags }));
    }
    return flags || {};
  } catch {
    return {};
  }
}
